module.exports = __webpack_public_path__ + "img/mycrypto-custom-token.302267a8.png";